




















































































































import Vue from "vue";
import { Rules } from "@ct/validations";
import UPDATE_USER_MUTATION from "@/graphql/UpdateUserMutation.gql";
import NEWSLETTER_SIGNUP_MUTATION from "@/graphql/NewsletterSignupMutation.gql";
import USER_QUERY from "@/graphql/UserQuery.gql";
import { AlertBar } from "@ct/alert";
import { UserQuery_user } from "@/graphql/generatedTypes/UserQuery";
import { UpdateUserMutation, UpdateUserMutationVariables } from "@/graphql/generatedTypes/UpdateUserMutation";
import { AuthRepository } from "@ct/auth";
import { RoleEnum } from "@/graphql/generatedTypes/globalTypes";
import UserAvatar from "@/views/UserAvatar.vue";
import globalState from "@/globalState";
import {
  NewsletterSignupMutation,
  NewsletterSignupMutationVariables
} from "@ct/conscioustransformation/src/graphql/generatedTypes/NewsletterSignupMutation";

export default Vue.extend({
  name: "UsersEdit",
  components: { AlertBar, UserAvatar },
  apollo: {
    user: {
      query: USER_QUERY,
      variables(): { id: string } {
        return {
          id: this.$route.params.id
        };
      }
    }
  },
  data() {
    return {
      user: {} as UserQuery_user,
      rules: Rules,
      passwordConfirmation: "",
      password: "",
      avatar: null as any,
      errors: {} as { [key: string]: string[] | undefined },
      currentUser: AuthRepository.getCurrentUser(),
      changePassword: false,
      RoleEnum
    };
  },
  computed: {
    allowedRoles(): RoleEnum[] {
      return [RoleEnum.PARTICIPANT, RoleEnum.TRAINER, RoleEnum.ADMIN].filter((role: RoleEnum) => {
        return this.currentUser && this.currentUser.canEdit(role);
      });
    }
  },
  methods: {
    async updateUser() {
      globalState.loading += 1;
      const result = await this.$apollo.mutate<UpdateUserMutation, UpdateUserMutationVariables>({
        mutation: UPDATE_USER_MUTATION,
        variables: {
          user: {
            id: this.user.id,
            firstName: this.user.firstName,
            lastName: this.user.lastName,
            avatar: this.avatar,
            email: this.user.email,
            bio: this.user.bio || "",
            phone: this.user.phone,
            imgRole: this.user.imgRole,
            ctRole: this.user.ctRole,
            password: this.password,
            passwordConfirmation: this.passwordConfirmation,
            newsletterSignedUp: this.user.newsletterSignedUp,
            trainerServices: this.user.trainerServices || null,
            communities: this.user.communities?.map((community: any) => community.id) || undefined,
            trainerMeetingLink: this.user.trainerMeetingLink
          }
        }
      });
      globalState.loading -= 1;

      if (result.data?.updateUser?.errors && result.data?.updateUser.errors.length > 0) {
        // eslint-disable-next-line no-unused-expressions
        await this.$alertService.addAlert({
          message: "There were some errors in your form",
          type: "error"
        });

        this.errors = result.data.updateUser.errors.reduce((memo, error) => {
          const { path } = error;
          if (!memo[path]) {
            memo[path] = [];
          }

          memo[path].push(error.message);

          return memo;
        }, {} as { [key: string]: string[] });

        await this.$vuetify.goTo(0);

        return;
      }

      if (result.data?.updateUser?.avatarUrl) {
        this.user.avatarUrl = result.data.updateUser.avatarUrl;
      }

      await this.$alertService.addAlert({
        message: "Your profile has been updated.",
        type: "success"
      });
      await this.$vuetify.goTo(0);
    },
    async addToNewsLetter() {
      if (!this.user.newsletterSignedUp) return null;

      const { data, errors } = await this.$apollo.mutate<NewsletterSignupMutation, NewsletterSignupMutationVariables>({
        mutation: NEWSLETTER_SIGNUP_MUTATION,
        variables: {
          email: this.$authRepository.getCurrentUser()?.email ?? "",
          firstName: this.$authRepository.getCurrentUser()?.firstName ?? "",
          lastName: this.$authRepository.getCurrentUser()?.lastName ?? ""
        }
      });

      if (errors) {
        await this.$vuetify.goTo(0);
        return await this.$alertService.addAlert({ message: errors[0].message, type: "error" });
      }

      if (data?.newsletterSignup?.errors && data.newsletterSignup.errors.length > 0) {
        await this.$vuetify.goTo(0);
        return await this.$alertService.addAlert({ message: data.newsletterSignup.errors[0].message, type: "error" });
      }

      if (data?.newsletterSignup?.ok) {
        await this.$vuetify.goTo(0);
        return await this.$alertService.addAlert({
          message: "Wohoo! We like you too! Keep your eyes peeled on your inbox every Tuesday for IMS happenings.",
          type: "success"
        });
      }
    }
  },
  watch: {
    changePassword() {
      this.password = "";
      this.passwordConfirmation = "";
    }
  }
});
